module.exports = __webpack_public_path__ + "static/media/john_wick_01.98006147.png";